import { connect } from 'react-redux'
import UserManagement from '../../components/Users/UserManagement'
import {getUsers} from "../../actions/index";

const mapStateToProps = state => {
    return {
        userName: state.auth.username,
        isAdmin: state.auth.adminInfo === 1,
        data: state.users.allUsers
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getUsers: () => {
            return dispatch(getUsers());
        },

    }

};


export default connect(
    mapStateToProps,
    mapDispatchToProps

)(UserManagement);
